module.exports = __webpack_public_path__ + "img/black_king_bar.51b1a20e.png";